import React from 'react';
import Layout from '../components/Layout';
import Hero from '../components/Hero';
import ServicesGrid from '../components/ServicesGrid';
import WorkShowcase from '../components/WorkShowcase';
import Process from '../components/Process';
import WhyUs from '../components/WhyUs';
import FAQ from '../components/FAQ';
import CallToAction from '../components/CallToAction';
import usePageMeta from '../hooks/usePageMeta';

const Home: React.FC = () => {
  usePageMeta({ path: '/' });

  return (
    <Layout>
      <Hero />
      <ServicesGrid />
      <WorkShowcase />
      <Process />
      <WhyUs />
      <FAQ />
      <CallToAction />
    </Layout>
  );
};

export default Home;
